// CRYPTO SCANNER PAGE
export const cryptoScannerContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #00d4aa 0%, #007a63 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Finance & Analytics
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Crypto Scanner', size: 'h1' },
        {
          type: 'text',
          content: 'Real-time cryptocurrency analysis and scanning tool',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A comprehensive crypto analysis platform with backend processing, frontend visualization, and browser extension for quick market insights.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <a
                href="https://crypto-scanner-three.vercel.app"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'linear-gradient(135deg, #00d4aa 0%, #007a63 100%)',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
              >
                Visit Live Site
              </a>
              <span style={{
                background: 'var(--bg-accent)',
                color: 'var(--text-accent)',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600'
              }}>
                Live
              </span>
            </div>
          )
        }
      ]
    },

    // LIVE EMBED SECTION
    {
      id: 'live-demo',
      title: 'Try Crypto Scanner Live',
      blocks: [
        {
          type: 'text',
          content: 'Experience the Crypto Scanner platform directly below. View real-time market data, analysis tools, and scanning features.',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '80vh',
              minHeight: '600px',
              background: '#000',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              border: '2px solid var(--border-color)'
            }}>
              <iframe
                src="https://crypto-scanner-three.vercel.app"
                title="Crypto Scanner Live Demo"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </div>
          )
        }
      ]
    },

    {
      id: 'architecture',
      title: 'System Architecture',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              {[
                { icon: '🖥️', title: 'Backend', desc: 'Python-based data processing and API' },
                { icon: '🌐', title: 'Frontend', desc: 'Interactive web dashboard for visualization' },
                { icon: '🔌', title: 'Chrome Extension', desc: 'Quick access to market data while browsing' },
                { icon: '💾', title: 'Database', desc: 'Historical data storage and analysis' }
              ].map((item, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>{item.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>{item.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>{item.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Technology Stack',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['Python', 'JavaScript', 'Chrome Extension API', 'REST API', 'SQLite'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Crypto Scanner',
    text: 'Real-time market intelligence',
    button: { text: 'Visit Live Site →', url: 'https://crypto-scanner-three.vercel.app' }
  }
};
